import * as React from "react";
import DeviceContext from "./../../service/indentifyDevice";
import urlConfig from "../../../config/domain";
import { apiService } from "./../../service/apiService";
import FeedbackForm from "./feedbackForm";
import { Link } from "react-router-dom";
import { scrollToEle } from "../../service/generic/scrollToEle";
import gtmService from "../../service/gtmService";

export interface IFooterContProps { }

interface IMarketStatus {
	exc: string;
	sts: string;
}

const FooterCont: React.FC<IFooterContProps> = () => {
	const [styles, setStyles] = React.useState({} as any);
	const [viewDisclaimer, setViewDisclaimer] = React.useState(false);
	const [marketStatus, setMarketStatus] = React.useState<Array<IMarketStatus>>([]);
	const [openFeedback, setOpenFeedback] = React.useState(false);
	const [contactpop, setContactPop] = React.useState(false);

	React.useEffect(() => {
		if (DeviceContext().isDesktop) {
			import("../../../assets/scss/components/footer/footer/footerContDsk.module.scss").then((style) => {
				setStyles(style.default);
			});
		} else if (DeviceContext().isTablet) {
			import("../../../assets/scss/components/footer/footer/footerContTab.module.scss").then((style) => {
				setStyles(style.default);
			});
		} else {
			import("../../../assets/scss/components/footer/footer/footerContMob.module.scss").then((style) => {
				setStyles(style.default);
			});
		}
	}, []);

	React.useEffect(() => {
		apiService(
			{
				url: urlConfig.market.market + "MarketStatus",
				method: "GET",
				appidkey: urlConfig.appidkey
			},
			(res: any) => {
				if (!res?.error) setMarketStatus(res);
			}
		);
	}, []);

	function onFeedbackClick() {
		setOpenFeedback(true);
		gtmService({
			...gtmFooterOptions,
			action: "Give us feedback",
			label: "mailto:Feedback_NVcom@nuvama.com?subject=Nuvama beta feedback"
		});
	}
	


	const gtmFooterOptions = { event: "event Footer", category: "Footer" };

	return Object.keys(styles).length ? (
		<div className={styles.ftr_cont}>
			<div className={styles.blue_bar}>
				<div className={DeviceContext().isMobile ? styles.text_left : styles.text_center}>
					<div className={styles.maindiv}>
					{DeviceContext().isMobile && (
							<div className={styles.bluebarblock}>
								<div className={styles.mobFaqs}>
								<a
									href={urlConfig.rootUrl + "faqs/what-are-the-detailed-charges-for-the-edelweiss-lite-plan-29-446"}
									className={[styles.faq, "pd_l5"].join(" ")}
									onClick={() => gtmService({ event: "event Subfooter", category: "Subfooter", action: "Faqs", labelUrlA: "faqs" })}>View FAQS</a>
								</div>
								<div className={styles.mobContact}>
								  <a  onClick={() => setContactPop(!contactpop)}>Contact us</a>
								</div>
								<div className={styles.mobQuery}>
								<a  href="{{urlConfig.rooturl+'/faqs/what-is-the-process-for-escalating-a-query-which-is-unanswered-13-191'}}">Raise Query</a>
								</div>
								{(DeviceContext().isMobile && contactpop) && (
									<div className ={styles.contact_popup}  onClick={() => setContactPop(!contactpop)}>
										<div className={styles.contact_card}>                                
											 <div className={styles.contact_cntr}>     
											     <span className={styles.contactclose }><i className="edel-icon-close "></i> </span>                          
												   <div className={styles.contactus }>Contact Us</div>
												  <div className={styles.availTimings}>Mon to Fri (8:30am - 5:30pm)<br /> Sat (10am - 2pm)</div>
												  <div className={styles.mobileNo }>1800 - 102 - 3335</div>
												  <div><a className={styles.m_link } href="mailto:helpdesk@nuvama.com" >helpdesk@nuvama.com</a></div>
											 </div>
										</div>
									</div>)}
							</div>
								
							
							)
							}
						
						
						{DeviceContext().isDesktop && (	
							<>
					<div className={styles.col}>
                        <div className={styles.row1}>Have Questions?</div>
                        <div className={styles.row2}>Visit our FAQ Section</div>
                        <div><a className={styles.alink} onClick={() => gtmService({ event: "event Subfooter", category: "Subfooter", action: "Faqs", labelUrlA: "faqs" })}
						href={urlConfig.rootUrl + "faqs/what-are-the-detailed-charges-for-the-edelweiss-lite-plan-29-446"}>View</a></div>
                    </div> 
					<div className={styles.bluebar_query}>
                      <div className={styles.querycol1}>
                        <div className={styles.row1}>Contact Us</div>
                        <div className={styles.row2}>1800 - 102 - 3335</div>
                        <div><a className={styles.alink} href="mailto:helpdesk@nuvama.com" gtmdir-cat="New_Postlogin Topnav" gtmdir-event="event New_HomePage" gtmdir-config gtmdir-key="Supportmail">helpdesk@nuvama.com</a></div>
                     </div>
                    <div className={styles.querycol2}>
                        <div className={styles.row1}>Mon to Fri (8:30am - 5:30pm)</div>
                        <div className={styles.row1}>Sat (10am - 2pm)</div>
                    </div>
                    </div>
                    <div className={styles.col}>
                        <div className={styles.row1}>Still have questions?</div>
                        <div className={styles.row2}>Raise a query</div>
                        <div><a className={styles.alink}  href="{{urlConfig.rooturl+'/faqs/what-is-the-process-for-escalating-a-query-which-is-unanswered-13-191'}}">Know how?</a></div>
                    </div></>)}
							
				
					</div>
				</div>
			</div>
			<section className={styles.maindiv1}>
				<div className={styles.col1}>
                        <div className={styles.col3}>
                            <div className={styles.boldheading}>ABOUT</div>
                            <div><a href={urlConfig.rootUrl +'/about-edelweiss-broking-limited'}>About Us</a></div>
                            <div><a href={urlConfig.rootUrl +'/inverstor-relations'}>Investor Relations</a></div>
                            <div><a href={urlConfig.rootUrl + "location"}
											onClick={() => gtmService({ ...gtmFooterOptions, action: "Locate Us", labelUrlA: "location" })}>Locate Us</a></div>
                            <div><a href={urlConfig.rootUrl + "partner-with-us"}
											onClick={() =>
												gtmService({ ...gtmFooterOptions, labelUrlA: "partner-with-us", action: "Partner with Us" })
											}>Partner with Us</a></div>
                            <div><a href={urlConfig.rootUrl + "our-pricing"}>Pricing</a></div>
                            <div><a href={urlConfig.rootUrl + "user-guide/web"} >User Guide</a></div>
                            <div><a href="https://www.edelweiss.in/refer/?utm_source=invitereferrals-referrer&utm_campaign=footer&utm_medium=website"
											target="_blank">Refer & Win</a></div>
                        </div>
                        <div className={styles.col4}>
                            <div className={styles.boldheading}>RESOURCES</div>
                            <div><a href={urlConfig.rootUrl + "demat-account"}>Demat Account</a></div>
                            <div><a href={urlConfig.rootUrl + "investology"}>Investology</a></div>
                            <div><a href={urlConfig.rootUrl + "research"}>Reports</a></div>
                            <div><a href={urlConfig.rootUrl + "codeofethicsandconduct"}
											onClick={() =>
												gtmService({ ...gtmFooterOptions, action: "Code of Ethics", labelUrlA: "codeofethicsandconduct" })
											}>Code of Ethics &amp;<br/>Conduct</a></div>
                            <div><a href={urlConfig.rootUrl + "dos-donts"}
											onClick={() => gtmService({ ...gtmFooterOptions, action: "Dos and Donts", labelUrlA: "dos-donts" })}>Do's & Don'ts</a></div>
                            <div><a href={urlConfig.rootUrl + "important-links"}>Important Links</a></div>
                            <div><a href={urlConfig.rootUrl + "/cas/microsite/Regulatory-Processes/"}>Regulatory Update</a></div>
                            <div><a href={urlConfig.rootUrl +'ewwebimages/webFiles/investor-charter/StockBroking.pdf'} target="_self" download="Investor Charter-Stock Broking"> Investor Charter-Stock Broking </a></div>
                            <div><a ng-href={urlConfig.rootUrl +'ewwebimages/webFiles/investor-charter/DepositoryParticipant.pdf'} target="_self" download="Investor Charter-Depository Participant"> Investor Charter-Depository Participant.</a></div>
                        </div>
                        <div className={styles.col3}>
                            <div className={styles.boldheading}>PLATFORMS</div>
                            <div><a href={urlConfig.rootUrl + "nuvama-markets-share-market-live-trading-app"}
											onClick={() => gtmService({ ...gtmFooterOptions, action: "Mobile Trader", labelUrlA: "nuvama-markets-share-market-live-trading-app" })}>Nuvama Markets</a></div>
                            <div><a href={urlConfig.rootUrl + "tx3"}
											onClick={() => gtmService({ ...gtmFooterOptions, action: "Terminal X3", labelUrlA: "extreme-trader" })}>TX3</a></div>
                            <div><a  href={urlConfig.rootUrl + "api-connect"}>API Connect</a></div>
                            <div><a href={urlConfig.rootUrl + "partners"}>Platform Partners</a></div>
                            <div className={styles.Partnergap}>OUR BUSINESS</div>
							<div><a href={urlConfig.rootUrl + "about-edelweiss-broking-limited"}>Securities Broking</a></div>
                            <div><a href={urlConfig.rootUrl + "about-edelweiss-broking-limited"}>Financial Products Distribution</a></div>
                            <div><a href={urlConfig.rootUrl + "about-edelweiss-broking-limited"}>Margin Trade Financing</a></div>
                        </div>
                        <div className={styles.col5}>
                            <div className={styles.boldheading}>FOLLOW US</div>
                            <div><a href="https://www.facebook.com/edelweissonline/"
										onClick={() =>
											gtmService({
												...gtmFooterOptions,
												action: "Sociallinks | facebook",
												label: "https://www.facebook.com/edelweissonline/"
											})
										}><i className={styles.sl_i + " edel-icon-facebook"}></i><span>Facebook</span></a></div>
                            <div><a href="https://www.linkedin.com/company/edelweiss-wealth-management/"
										onClick={() =>
											gtmService({
												...gtmFooterOptions,
												action: "Sociallinks | linkedin",
												label: "https://www.linkedin.com/company/edelweiss-wealth-management/"
											})
										}><i className={styles.linkedin + " edel-icon-linkedin"}></i><span>Linkedin</span></a></div>
                            <div><a href="https://twitter.com/EdelweissWM" onClick={() =>
											gtmService({
												...gtmFooterOptions,
												action: "Sociallinks | twitter",
												label: "https://twitter.com/EdelweissWM"
											})
										}><i className={styles.twitter + " edel-icon-twitter"}></i><span>Twitter</span></a></div>
                            <div><a href="https://www.instagram.com/edelweisswealthmanagement/"
										onClick={() =>
											gtmService({
												...gtmFooterOptions,
												action: "Sociallinks | instagram",
												label: "https://www.instagram.com/edelweisswealthmanagement/"
											})
										}><i className={styles.insta + " edel-icon-instagram"}></i><span>Instagram</span></a></div>
                        </div>
                    </div>
				    <div className={styles.col2}>
                        <div className={styles.feedback}>Give Us Feedback!</div>
                        <p>We welcome your suggestions and ideas. With over a million members we constantly improve our services.</p>  
						<div className={styles.feedbacklink}>
						    <a className={styles.ftrfeedback_btn} id="edelFeedback" onClick={onFeedbackClick}>
							Give feedback
						   </a>
				     	</div>  
				    </div>
			</section>
			<section className={styles.footerbottom}>
		     	<div className={styles.footerbottomcntr}>
					<div className={styles.policyrow}>
					    <div className ={styles.policy}>
							<div><a ui-sref="disclaimer" gtmdir-cat="New_Postlogin Topnav" gtmdir-event="event New_HomePage" gtmdir-config gtmdir-text="Disclaimer" gtmdir-url='disclaimer' gtmdir-key="Footeroptions">Disclaimer </a></div>
							<div><a ui-sref="privacypolicy" gtmdir-cat="New_Postlogin Topnav" gtmdir-event="event New_HomePage" gtmdir-config gtmdir-text="Privacy Policy" gtmdir-url='privacypolicy' gtmdir-key="Footeroptions">Privacy Policy </a></div>
							<div><a ui-sref="termsofuse" gtmdir-cat="New_Postlogin Topnav" gtmdir-event="event New_HomePage" gtmdir-config gtmdir-text="Terms of Use" gtmdir-url='termsofuse' gtmdir-key="Footeroptions">Terms of Use</a></div>
							<div><a ng-href="https://www.edelweiss.in/ewwebimages/webFiles/disclaimer/Complaints.pdf" target="_self" download="Complaints" href="https://www.edelweiss.in/ewwebimages/webFiles/disclaimer/Complaints.pdf">Investor Complaints</a></div>
					 	</div>
						 <div className={styles.copyright}>
                                <p>&copy; All rights reserved 2020</p> 
                        </div>
				    </div>

					{DeviceContext().isMobile && (
						<div className={styles.DisclaimerCntr}>
							<div className={styles.viewDisclaimer}>
								<button onClick={() => setViewDisclaimer(!viewDisclaimer)}>View Full Disclaimer</button>
								{(!DeviceContext().isMobile || (DeviceContext().isMobile && viewDisclaimer)) && (
									<p className={styles.disclaimer}>
										Broking services offered by Nuvama Wealth and Investment Limited (NWIL), known as Edelweiss Broking Limited, is a 100% subsidiary of Nuvama Wealth Management Limited . Registered office of NWIL is at 201 to 203, Zodiac Plaza, Xavier College Road, Off C G Road, Ahmedabad, Gujarat - 380009. Contact: (079) 40019900 / 66629900. Corporate Office address is Edelweiss House, Off CST Road, Kalina, Mumbai - 400098. It is a Member of National Stock Exchange of India Ltd (Member Code: 13116), BSE Ltd (Member Code :3261), Multi Commodity Exchange of India Limited (Member Code :56520), Metropolitan Stock Exchange (Member Code :86100) and National Commodity and Derivatives Exchange Limited (Member Code :01279) and having SEBI registration no. INZ000005231. Depository Participant SEBI Registration No.: IN-DP-656-2021 with NSDL having DP ID: IN302201 & IN303719 and with CDSL having DP ID: 12032300. Research services are offered by NWIL under SEBI Registration No. INH000000172. Name of the Compliance officer: Mr. Pranav Tanna, E-mail address: complianceofficer.nwil@nuvama.com. Investments in securities market are subject to market risks, read all the related documents carefully before investing. 
											<br/>The contents herein shall not be considered as an invitation or persuasion to trade or invest.  NWIL and affiliates accept no liabilities for any loss or damage of any kind arising out of any actions taken in reliance thereon. Please note Brokerage would not exceed the SEBI prescribed limit. NWIL also acts in the capacity of distributor for Products such as PMS, OFS, Mutual Funds, IPOs and/or NCD etc. All disputes with respect to the distribution activity, would not have access to Exchange investor redressal forum or Arbitration mechanism.
											<br/>NWIL also acts in the capacity of distributor of Edelweiss Mutual Fund and other AMCs under AMFI Registration Number – 70892 and in capacity of a Corporate Agent; registered with IRDA having Licence number: CA0131. Mutual Fund Investments are subject to market risks. Please read all scheme related documents carefully before investing. Investment in the securities involves risks. The user is required to undergo risk profiling before investing. Guided view is indicative in nature and is based on the information provided by the user voluntarily. Each user of this information should make such investigation as it deems necessary to arrive at an independent evaluation of an investment in the securities of companies referred here (including the merits and risks involved) and should consult his own advisors to determine the merits and risks of such investment. Past performance is not necessarily a guide to future performance. <br/>
											<br/>Trading Accounts would be open after all procedure relating to client registration, IPV and client due diligence is completed. Margin Trading facility is offered by NWIL in terms of the provisions of SEBI Circular CIR/MRD/DP/54/2017 dated June 13, 2017, and the terms and conditions mentioned in rights and obligations statement issued.
											<br/>For any grievance relating to Stock Broking/ DP operations, please call 040-41151621 or write to helpdesk; Email ID: helpdesk@nuvama.com (for trading related) and dpservicesnwil@nuvama.com (for demat related).
											<br/><br/><strong>Margin Pledge Awareness</strong>
											<br/>1. Stock Brokers can accept securities as margin from clients only by way of pledge in the depository system w.e.f. September 01, 2020.
											<br/>2. Update your email id and mobile number with your stock broker / depository participant and receive OTP directly from depository on your email id and/or mobile number to create pledge.
                        					<br/>3. Check your securities / MF / bonds in the consolidated account statement issued by NSDL/CDSL every month.
								   </p>
				            	)}
							</div>
					</div>
			    	)}
				

					<div className={styles.ticker}>
						<div className={styles.marquee_head + " " + styles.width}>Attention Investors</div>
						<div className={styles.marquee_msg}>
							<p>
								<a href="https://www.bseipf.com/WIW_2020.html" className={styles.wiw} target="_blank" rel="noreferrer">
									World Investor Week November 23-29, 2020 being celebrated under the aegis of IOSCO and SEBI.
								</a>{" "}
								Stock Brokers can accept securities as margin from clients only by way of pledge in the depository system w.e.f.
								September 1, 2020, Update your mobile number & email Id with your stock broker/depository participant and receive OTP
								directly from depository on your email id and/or mobile number to create pledge, Pay 20% upfront margin of the
								transaction value to trade in cash market segment, Investors may please refer to the Exchange's Frequently Asked
								Questions (FAQs) issued vide circular reference NSE/INSP/45191, 20200731-7 (BSE) dated July 31, 2020 and
								NSE/INSP/45534, 20200831-45 (BSE) dated August 31, 2020 and other guidelines issued from time to time in this regard,
								Check your Securities /MF/ Bonds in the consolidated account statement issued by NSDL/CDSL every month, We have
								discontinued the facility for sending physical documents till situation normalise with regard to transactions carried
								out through exchanges and depositories. You will be receiving the documents in electronic mode instead of physical.
								Kindly update the current email id in this regard.&nbsp;&nbsp;|&nbsp;&nbsp;Broking services offered
								by&nbsp;-&nbsp;Nuvama Wealth and Investment Ltd. under SEBI Registration no. INZ000005231 (NSE, BSE &amp; MSEI. Corporate office:
								Edelweiss House, OFF CST Road, Kalina, Mumbai - 400098, Tel. (022) 4009 4400 / 2286 4400.&nbsp;&nbsp;|&nbsp;&nbsp;KYC
								is one time exercise while dealing in securities markets&nbsp;-&nbsp;Once KYC is done through a SEBI registered
								intermediary (broker, DP, Mutual Fund, etc.), you need not undergo the same process again when you approach another
								intermediary.&nbsp;&nbsp;|&nbsp;&nbsp;Prevent unauthorised transactions in your trading account&nbsp;-&nbsp;Update
								your mobile numbers/email IDs with your stock broker(s). Receive information of your transactions directly from
								exchange on your mobile/email at the end of the day.&nbsp;&nbsp;|&nbsp;&nbsp;Prevent unauthorized transactions in your
								demat account&nbsp;-&nbsp;Update your mobile number with your Depository Participant, to receive alerts on your
								registered mobile number for all debit and other important transactions in your demat account directly from NSDL/CDSL
								on the same day. - Issued in the interest of the investors.&nbsp;&nbsp;|&nbsp;&nbsp;SEBI Notification for all
								investors including retail individual investors for all public issues opening on or after January 01,
								2016&nbsp;-&nbsp;No need to issue cheques by investors while subscribing to IPO. Just write the bank account number
								and sign in the application form to authorise your bank to make payment in case of allotment. No worries for refund as
								the money remains in investor's account.
							</p>
						</div>
					</div>
					<div className={styles.btm_row}>
					 <div className={styles.tickerMarket}>
						<div className={styles.marquee_head}>Market Status:</div>
						<div className={styles.mkt_sts}>
							{marketStatus.map((mkt) => (
								<span className={styles.market_sts} key={mkt.exc}>
									<span>{mkt.exc}</span>&nbsp;&nbsp;-&nbsp;&nbsp;
									<span className={mkt.sts === "Open" ? styles.open : styles.closed}>{mkt.sts}</span>{" "}
								</span>
							))}
						</div>
				    	</div>
				    	<div className={styles.web_version}>
						<p>
							<a href="https://scores.gov.in/scores/Welcome.html" target="_blank" rel="noreferrer">
								SEBI SCORES
							</a>{" "}
							| Nuvamawealth.com(TOC) - Ver. 1.0.2
						</p>
					</div>
				</div>

				</div>
			</section>
			{openFeedback && <FeedbackForm onClose={() => setOpenFeedback(false)} />}
		</div>
	) : (
		<></>
	);
};

export default FooterCont;
